import { clients } from '../clients/grpcClients';
import { useLocalStorage } from '../stores/localStorage';
import {
  AddGCSObjectsToVectorStoreRequest,
  AddGCSObjectsToVectorStoreResponse,
  ListMessagesOnThreadRequest,
  ListMessagesOnThreadResponse,
  RequestFlag,
  SendMessageRequest,
  SendMessageResponse,
  StreamMessageRequest,
  StreamMessageResponse,
} from './protosCompiled/assistants/assistants_pb';

const client = clients.assistantServiceClient;

export class AssistantService {
  private static getMetadata() {
    const sessionToken = useLocalStorage.getState().sessionToken;
    if (!sessionToken) {
      console.error('Session token is missing!');
    }
    return {
      sessionToken,
    };
  }

  // public static sendAIMessage = ({
  //   usermessage,
  //   objectid,
  //   objectdata,
  //   projectid,
  //   estimateid,
  // }: {
  //   usermessage: string;
  //   objectid?: string;
  //   objectdata?: Uint8Array;
  //   projectid: string;
  //   estimateid: string;
  // }): Promise<SendMessageResponse.AsObject> => {
  //   return new Promise((resolve, reject) => {
  //     const req = new SendMessageRequest();
  //     try {
  //       req.setUsermessage(usermessage);
  //       req.setSessiontoken(this.getMetadata().sessionToken);
  //       req.setProjectid(projectid);
  //       req.setEstimateid(estimateid);
  //     } catch (error) {
  //       alert('Error setting required fields');
  //       return;
  //     }
  //     try {
  //       req.setObjectid(objectid || '');
  //       req.setObjectdata(objectdata || new Uint8Array());
  //     } catch (error) {
  //       alert('Error setting optional fields');
  //       return;
  //     }
  //     client.sendMessage(req, {}, (err, response) => {
  //       if (err) {
  //         reject(err);
  //         return;
  //       }
  //       resolve(response.toObject());
  //     });
  //   });
  // };

  public static addGCSObjectsToVectorStore = ({
    projectid,
    objectid,
  }: {
    projectid: string;
    objectid: string;
  }): Promise<AddGCSObjectsToVectorStoreResponse.AsObject> => {
    return new Promise((resolve, reject) => {
      const request = new AddGCSObjectsToVectorStoreRequest();
      request.setSessiontoken(this.getMetadata().sessionToken);
      request.setProjectid(projectid);
      request.setObjectid(objectid);
      client.addGCSObjectsToVectorStore(request, {}, (err, response) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(response.toObject());
      });
    });
  };

  static listMessagesOnThread = ({
    projectid,
  }: {
    projectid: string;
  }): Promise<ListMessagesOnThreadResponse.AsObject> => {
    return new Promise((resolve, reject) => {
      const request = new ListMessagesOnThreadRequest();
      request.setSessiontoken(this.getMetadata().sessionToken);
      request.setProjectid(projectid);
      client.listMessagesOnThread(request, {}, (err, response) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(response.toObject());
      });
    });
  };

  /**
   *
   * When you call this function you wil need to set a request flag of type RequestFlag.
   * These flags will be used in the backend to understand which agentic workflow to run.
   *
   * Possible values are:
   * - REQUEST_FLAG_UNSPECIFIED -- This is the default value. This will run the default workflow.
   * - REQUEST_FLAG_RENAME_DOCUMENT -- This flag will run a workflow that scans construction documents and returns a response with the following object:
   * {
   *   "gcs_object_names": ["uuid1.pdf", "uuid2.pdf", "uuid3.pdf"],
   *   "sheet_names": ["new_name1", "new_name2", "new_name3"],
   *   "sheet_numbers": ["E.1", "E.2", "E.3"]
   * }
   *
   */
  public static streamMessage = ({
    usermessage,
    objectid,
    objectdata,
    projectid,
    estimateid,
    requestflag,
    gcsobjectnames,
    onMessage,
  }: {
    usermessage: string;
    objectid?: string;
    objectdata?: Uint8Array;
    projectid: string;
    estimateid: string;
    requestflag: RequestFlag;
    gcsobjectnames?: string[];
    onMessage?: (message: string) => void;
  }): Promise<void> => {
    return new Promise((resolve, reject) => {
      if (requestflag === RequestFlag.REQUEST_FLAG_RENAME_DOCUMENT && !gcsobjectnames) {
        alert(
          'You need to include a list of gcsObjectNames <uuid.pdf> when using the REQUEST_FLAG_RENAME_DOCUMENT flag'
        );
        reject(
          new Error(
            'You need to include a list of gcsObjectNames <uuid.pdf> when using the REQUEST_FLAG_RENAME_DOCUMENT flag'
          )
        );
        return;
      }

      const req = new StreamMessageRequest();
      try {
        req.setUsermessage(usermessage);
        req.setSessiontoken(this.getMetadata().sessionToken);
        req.setProjectid(projectid);
        req.setEstimateid(estimateid);
        req.setRequestflag(requestflag);
        req.setGcsobjectnamesList(gcsobjectnames || []);
      } catch (error) {
        alert('Error setting required fields');
        reject(error);
        return;
      }
      try {
        req.setObjectid(objectid || '');
        req.setObjectdata(objectdata || new Uint8Array());
      } catch (error) {
        alert('Error setting optional fields');
        reject(error);
        return;
      }

      const stream = client.streamMessage(req, {});

      stream.on('data', (response: StreamMessageResponse) => {
        const content = response.getResponsemessage();
        if (content) {
          onMessage && onMessage(content);
        }
        // You can further process the streamed response here
        return;
      });

      stream.on('error', (err: Error) => {
        console.error('Stream encountered an error:', err);
        reject(err);
      });

      stream.on('end', () => {
        resolve();
      });
    });
  };
}
